import { toastr } from 'react-redux-toastr';
import { SECONDARY_MENU_ACTION_TYPES } from './actionTypes';
import { secondaryMenuApi } from './api';

export const secondaryMenuActions = {
    fetchRequest: () => ({
        type: SECONDARY_MENU_ACTION_TYPES.FETCH_REQUEST,
    }),
    fetchSuccess: (data) => ({
        type: SECONDARY_MENU_ACTION_TYPES.FETCH_SUCCESS,
        payload: data,
        meta: { timestamp: Date.now() },
    }),
    fetchFailure: (error) => ({
        type: SECONDARY_MENU_ACTION_TYPES.FETCH_FAILURE,
        payload: error,
        error: true,
    }),
};

export const fetchSecondaryMenu = () => {
    return async (dispatch, getState) => {
        const state = getState().secondaryMenu;
        if (state.loading) return;

        dispatch(secondaryMenuActions.fetchRequest());

        try {
            const data = await secondaryMenuApi.fetch();
            dispatch(secondaryMenuActions.fetchSuccess(data));
        } catch (error) {
            console.error('Secondary menu fetch error:', error);
            dispatch(secondaryMenuActions.fetchFailure(error.message));
            toastr.error('Ошибка', `Не удалось загрузить меню: ${error.message}`);
        }
    };
};
